import { secureApiGet } from '../secureHttp';
import type { Patient } from '../../../types/patient';

type AnyRecord = Record<string, unknown>;

function isRecord(v: unknown): v is AnyRecord {
  return typeof v === 'object' && v !== null;
}

export async function getPatientDetail(id: string): Promise<Patient> {
  const resp = await secureApiGet<unknown>(`/v1/patients`, { id });
  const fallback: Patient = { id, email: '', name: '', phone: '' };

  const normalizeOne = (input: unknown): Patient | null => {
    if (!isRecord(input)) return null;
    const obj = input as AnyRecord;
    const take = (key: string): unknown => (key in obj ? obj[key] : undefined);
    const user = isRecord(take('user')) ? (take('user') as AnyRecord) : undefined;
    const email = String((take('email') ?? user?.email ?? '') || '');
    const nameParts = [take('name'), take('surname')].filter(Boolean).map(String);
    const name = nameParts.length > 0 ? nameParts.join(' ') : String(take('name') ?? '');
    const phone = String((take('phone') ?? '') || '');
    const occupation = String((take('occupation') ?? '') || '');
    const source = String((take('source') ?? '') || '');
    const timezone = String((take('timezone') ?? '') || '');
    const pid = String((take('id') ?? id) || id);
    return {
      id: pid,
      email,
      name,
      phone,
      occupation: occupation || undefined,
      source: source || undefined,
      timezone: timezone || undefined
    };
  };

  if (Array.isArray(resp)) {
    return normalizeOne(resp[0]) ?? fallback;
  }
  if (isRecord(resp)) {
    const obj = resp as AnyRecord;
    const arr = Array.isArray(obj.results) ? obj.results : (Array.isArray(obj.data) ? obj.data : undefined);
    if (arr && arr.length > 0) return normalizeOne(arr[0]) ?? fallback;
  }
  return fallback;
}


